import { useQuery } from "@apollo/client";
import { useAuthStore } from "@/lib/store/auth-enhanced";
import { ACTIVE_PROMO_EVENT_QUERY } from "@/lib/whatsapp-promo/graphql/promo";

/**
 * Fetches the single currently-active promo event.
 * Skips the request entirely when the user is not authenticated.
 */
export function useActivePromo() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  const { data, loading } = useQuery(ACTIVE_PROMO_EVENT_QUERY, {
    skip: !isAuthenticated,
    errorPolicy: "ignore",
    fetchPolicy: "cache-and-network",
  });

  return { promo: data?.activePromoEvent ?? null, loading } as const;
}
